export default function FaqData() {
  return [
    {
        title: "Why should I consider disability insurance for my income protection needs?",
        text: [
                "According to the U.S. Social Security Administration, just over one in four of today’s 20-year old's will become disabled before they retire.",
                "At the beginning of 2019, Social Security paid an average monthly disability benefit of about $1,234 to all disabled workers; barely enough to keep a beneficiary above the 2018 poverty level.",
                "According to the U.S. Census Bureau, as of June 2020 there is approximately 12.6% or 40.6 million disabled Americans. About 50% of those disabled Americans are in their working years, ages 18-64.",
                "A study released by the Council for Disability Awareness indicated that 65% of working Americans say they could not cover normal living expenses even for a year if their employment income was lost; 38% could not pay their bills for more than three months.",
        ]
    },
    {
        title: "What is disability insurance?",
        text: [
            "Disability insurance is a type of insurance that provides income in the event a worker is unable to work or earn money because of a disability."
        ]
    },
    {
        title: "Will I ever user disability coverage?",
        text: [
            "If you were to suffer a disabling injury or illness that keeps you from earning a living, long-term disability insurance greatly reduces the risk of financial setbacks during this period. Without a policy, you may be at risk of not being able to afford everyday essentials, mortgage, bills, or to take care of your family."
        ]
    },
    {
        title: "What does long-term disability insurance cover?",
        text: [
            "Long-term disability insurance is ideal for serious injuries and illnesses that may keep you from working for months, years, or even permanently. Long-term disability benefits are typically paid on a monthly basis and can replace up to 60% of your pre-tax income. Leading causes of claims include musculoskeletal disorders like arthritis and back pain, as well as cancer, heart attack, and stroke."
        ]
    },
    {
        title: "How do long-term disability insurance benefits work?",
        text: [
            "If you become disabled and file a claim for benefits with your insurer, you will receive a benefit amount to help replace a portion of the income you lose while you’re unable to work. It’s important to understand that any benefits you receive from your disability insurance policy are your money to use however you want. Make your mortgage, student loan, and car payments; cover out-of-pocket medical expenses; buy groceries and take care of your family; stay on track with retirement savings. <em>Literally whatever you need</em>"
        ]
    },
    {
        title: "How much does long-term disability insurance cost?",
        text: [
            "The price of Disability Insurance depends on the gender of the insured, length of the elimination period, how long a person receives a disability benefit and the profession of the person receiving the disability benefit."
        ]
    },
    {
        title: "How does my job impact the cost of disability insurance?",
        text: [
            "To determine the pricing and benefits of policies, disability insurance companies group jobs into specific occupational classes. These classes take into account the hazards of the job. Another factor is the claim experience associated with certain professions.",
            "Insurance companies generally classify occupations on a scale of 1 to 5 or 6. Typically, the higher the number the lower the rate available from the insurance company.",
            "Insurance companies also have to assess jobs based on the difficulty in returning to work following a disability. That’s because certain disabilities would hinder the ability to do some jobs, but not others."
        ]
    },
    {
        title: "What is an elimination period?",
        text: [
            "Regardless of the type of disability insurance you purchase, there will be a period of time called the elimination period that the worker must be disabled before they can begin receiving disability benefits. If the worker is able to work before the elimination period, they will not receive any benefits."
        ]
    },
]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LongTermDisability/FaqData.js